module.exports = __webpack_public_path__ + "af073ddca7ac36e0df2f1060578cfa36.svg";